import { createBrowserRouter, Navigate } from 'react-router';

import { ErrorBoundary } from '../components/ErrorBoundary';
// import ErrorBoundary from '../components/ErrorBoundary';
import AuthLayout from '../layout/Auth/AuthLayout';
import DashboardLayout from '../layout/UsersDashboard/DashboardLayout';
import EnterNewPassword from '../pages/Auth/ForgotPassword/EnterNewPassWord';
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword';
import ForgotPasswordSuccess from '../pages/Auth/ForgotPassword/ForgotPasswordSuccess';
import PasswordResetSuccess from '../pages/Auth/ForgotPassword/PasswordResetSuccess';
import SignIn from '../pages/Auth/SignIn/SignIn';
import SignUp from '../pages/Auth/SignUp/SignUp';
import SignupOtp from '../pages/Auth/SignupOtp/SignupOtp';
import Application from '../pages/Dashboard/Application/Application';
import Bookmarks from '../pages/Dashboard/Bookmarks/Bookmarks';
import DashboardHome from '../pages/Dashboard/Dashboard/DashboardHome';
import FindLocum from '../pages/Dashboard/Findlocum/FindLocum';
import InvitedJobs from '../pages/Dashboard/InvitedJobs/InvitedJobs';
import LocumJobs from '../pages/Dashboard/LocumJobs/LocumJobs';
import ManagePostedJobs from '../pages/Dashboard/ManagePostedJobs/ManagePostedJobs';
import ManagePostJobApplicant from '../pages/Dashboard/ManagePostJobApplicant/ManagePostJobApplicant';
import Notifications from '../pages/Dashboard/Notifications/Notifications';
import Referrals from '../pages/Dashboard/Referrals/Referrals';
import Settings from '../pages/Dashboard/Settings/Settings';
import BillingHistoryPage from '../pages/Dashboard/Subscriptions/BillingHistoryPage';
import SubscriptionConfirmationPage from '../pages/Dashboard/Subscriptions/SubscriptionConfirmationPage';
import SubscriptionPlansPage from '../pages/Dashboard/Subscriptions/SubscriptionPlansPage';
import ViewOnlyJobs from '../pages/Guest/ViewOnlyJobs';
import ViewOnlyLocums from '../pages/Guest/ViewOnlyLocums';
import { NotFound404 } from '../pages/NotFound404';
import Unsubscribe from '../pages/Unsubscribe/Unsubscribe';
import ReferralCapture from '../pages/Auth/ReferralCapture/ReferralCapture';
import {
  ACCOUNT,
  APPLICATION,
  BOOKMARKS,
  DASHBOARD,
  FIND_LOCUM,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  INVITED_JOBS,
  LOCUMJOBS,
  MANAGE_POSTED_JOBS,
  NOTFOUND,
  NOTIFICATIONS,
  PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  REFERRAL_CAPTURE,
  REFERRALS,
  SIGNIN,
  SIGNUP,
  SIGNUP_OTP,
  SUBSCRIPTIONS_CONFIRMATION,
  SUBSCRIPTIONS_HISTORY,
  SUBSCRIPTIONS_PLANS,
  UNSUBSCRIBE,
  USERS_SETTINGS,
  VIEW_ONLY_JOBS,
  VIEW_ONLY_LOCUMS,
} from './routeConstants';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: '/', element: <Navigate to={DASHBOARD} /> },
      { path: DASHBOARD, element: <DashboardHome /> },
      { path: LOCUMJOBS, element: <LocumJobs /> },
      { path: APPLICATION, element: <Application /> },
      { path: USERS_SETTINGS, element: <Settings /> },
      { path: NOTIFICATIONS, element: <Notifications /> },
      { path: BOOKMARKS, element: <Bookmarks /> },
      { path: FIND_LOCUM, element: <FindLocum /> },
      { path: INVITED_JOBS, element: <InvitedJobs /> },
      { path: REFERRALS, element: <Referrals /> },
      { path: SUBSCRIPTIONS_PLANS, element: <SubscriptionPlansPage /> },
      { path: SUBSCRIPTIONS_HISTORY, element: <BillingHistoryPage /> },
      {
        path: SUBSCRIPTIONS_CONFIRMATION,
        element: <SubscriptionConfirmationPage />,
      },
      {
        path: `${DASHBOARD}/${MANAGE_POSTED_JOBS}`,
        element: <ManagePostedJobs />,
      },
      {
        path: `${DASHBOARD}/${MANAGE_POSTED_JOBS}/:jobId`,
        element: <ManagePostJobApplicant />,
      },

      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },

  {
    path: ACCOUNT,
    element: <AuthLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: SIGNIN, element: <SignIn /> },
      { path: SIGNUP, element: <SignUp /> },
      { path: SIGNUP_OTP, element: <SignupOtp /> },

      { path: FORGOT_PASSWORD, element: <ForgotPassword /> },
      { path: FORGOT_PASSWORD_SUCCESS, element: <ForgotPasswordSuccess /> },
      { path: `${PASSWORD_RESET}/:id/:token`, element: <EnterNewPassword /> },
      {
        path: `${PASSWORD_RESET_SUCCESS}`,
        element: <PasswordResetSuccess />,
      },

      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },
  {
    path: VIEW_ONLY_JOBS,
    element: <ViewOnlyJobs />,
  },
  {
    path: VIEW_ONLY_LOCUMS,
    element: <ViewOnlyLocums />,
  },
  {
    path: REFERRAL_CAPTURE,
    element: <ReferralCapture />,
  },
  {
    path: `${UNSUBSCRIBE}`,
    element: <Unsubscribe />,
  },
  {
    path: '*',
    errorElement: <ErrorBoundary />,
    element: <NotFound404 />,
  },
]);
